import { Layout } from 'components/layout';
import { Spinner } from 'components/spinner';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const LogoutPage = () => {
  const router = useRouter();
  useEffect(() => {
    fetch('/api/auth/logout').then((r) => {
      localStorage.removeItem('jwt');
      localStorage.removeItem('basket');
      location.assign('/');
    });
  }, []);

  return (
    <Layout pageName='Log out'>
      <article className='flex flex-col justify-center max-w-screen-2xl mx-auto py-16 space-y-16'>
        <h1 className='mx-auto header text-4xl'>Logging Out</h1>
        <div className='mx-auto'>
          <Spinner size={10} color='yellow-default' />
        </div>
      </article>
    </Layout>
  );
};

export default LogoutPage;
